import { observable } from "mobx";
import { Type } from "class-transformer";

import ChargeResponse from "./chargeResponse";
import TransferPaymentResponse from "./transferPaymentResponse";
import { ChargeOrderStatus } from "models/chargeOrder";
import ProposedAfterPurchaseRedirectResponse from "./proposedAfterPurchaseRedirectResponse";
import TransferPaymentInstructionsResponse from "./transferPaymentInstructionsResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOrderResponse {
  /**
   * Charge order ID.
   */
  id!: string;

  /**
   * Order identifier = variable symbol for the payment.
   */
  @observable
  orderIdent!: number;

  @observable
  @Type(() => TransferPaymentInstructionsResponse)
  transferPaymentInstructions?: TransferPaymentInstructionsResponse;

  @observable
  status!: ChargeOrderStatus;

  /**
   * Payment amount.
   */
  @observable
  paymentAmount!: number;

  @observable
  @Type(() => ProposedAfterPurchaseRedirectResponse)
  proposedAfterPurchaseRedirect?: ProposedAfterPurchaseRedirectResponse;

  /**
   * The list of charges.
   */
  @observable
  @Type(() => ChargeResponse)
  charges!: ChargeResponse[];
}
